var React = require('react');

function CloseRoundLg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.5 38.3207C31.2376 38.3207 38.3207 31.2376 38.3207 22.5C38.3207 13.7625 31.2376 6.67932 22.5 6.67932C13.7625 6.67932 6.67932 13.7625 6.67932 22.5C6.67932 31.2376 13.7625 38.3207 22.5 38.3207Z","strokeWidth":"1.59601","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M28.0077 16.8284L16.7858 28.0504","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M16.7858 16.8284L28.0077 28.0504","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CloseRoundLg.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = CloseRoundLg;

CloseRoundLg.default = CloseRoundLg;
